import React from 'react';
import { Afiliaciones } from '../../components';

const AfiliacionesPage = () => {
  return (
    <>
      <Afiliaciones />
    </>
  );
};

export default AfiliacionesPage;
